module.exports = __webpack_public_path__ + "static/media/header-light-logo.0bd96498.svg";